.hostConference :global(.lk-grid-layout-wrapper),
.hostConference :global(.lk-focus-layout-wrapper) {
  flex: 1;
  min-height: 0;
  height: auto;
}

.hostConference :global(.lk-video-conference-inner) {
  min-width: 0;
  min-height: 0;
}

.testMode {
  box-sizing: border-box;
  border: 0.5rem solid #ef4444;
}

.testModeBanner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  display: flex;
  justify-content: center;
}

.testModeLabel {
  padding: 0 1rem 0.25rem;
  border-radius: 0 0 0.5rem 0.5rem;
  background-color: #ef4444;
  color: #fff;
}
